<span
	style="color: rgb(0, 0, 0); background: rgb(0, 0, 0);"
	onmouseover="this.style.color='#FFFFFF';"
	onmouseout="this.style.color='#000000';"
>
	<slot />
</span>
